/* azh-freebie-picker: keeps the _freebie_* fields in step with the checked oil,
   honours the saved preference, and runs the all-oils sheet. */
(function () {
  'use strict';

  var PREF_KEY = 'azhara_freebie_pref';
  var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (root.__azhFp) return;
    root.__azhFp = true;

    var strip = root.querySelector('[data-azh-fp-strip]');
    var note = root.querySelector('[data-azh-fp-note-name]');
    var worth = root.querySelector('[data-azh-fp-note-worth]');
    var openBtn = root.querySelector('[data-azh-fp-open]');
    var sheet = root.querySelector('[data-azh-fp-sheet]');
    var fields = {};
    root.querySelectorAll('[data-azh-freebie-field]').forEach(function (input) {
      fields[input.getAttribute('data-azh-freebie-field')] = input;
    });
    if (!strip) return;

    function radios() {
      return Array.prototype.slice.call(strip.querySelectorAll('.azh-fp-input'));
    }

    function checkedRadio() {
      return strip.querySelector('.azh-fp-input:checked');
    }

    function cardFor(radio) {
      return radio.closest('[data-azh-fp-card]');
    }

    function revealCard(card) {
      if (card.hidden) {
        card.hidden = false;
        strip.insertBefore(card, strip.firstChild);
      }
    }

    function scrollCardIntoView(card) {
      var left = card.offsetLeft - strip.offsetLeft;
      var right = left + card.offsetWidth;
      if (left < strip.scrollLeft) {
        strip.scrollTo({ left: Math.max(0, left - 3), behavior: 'smooth' });
      } else if (right > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: right - strip.clientWidth + 20, behavior: 'smooth' });
      }
    }

    function sync() {
      var radio = checkedRadio();
      radios().forEach(function (r) {
        cardFor(r).classList.toggle('is-on', r === radio);
      });
      if (!radio) return;
      var handle = radio.getAttribute('data-handle') || '';
      if (fields.handle) fields.handle.value = handle;
      if (fields.img) fields.img.value = radio.getAttribute('data-img') || '';
      if (fields.price) fields.price.value = radio.getAttribute('data-price') || '';
      if (note) note.textContent = radio.value;
      if (worth) worth.textContent = radio.getAttribute('data-worth') || '';
      if (sheet) {
        sheet.querySelectorAll('[data-azh-fp-pick]').forEach(function (cell) {
          cell.setAttribute('aria-checked', cell.getAttribute('data-azh-fp-pick') === handle ? 'true' : 'false');
        });
      }
    }

    function choose(radio, save) {
      var card = cardFor(radio);
      revealCard(card);
      radio.checked = true;
      sync();
      scrollCardIntoView(card);
      if (save) {
        try { localStorage.setItem(PREF_KEY, JSON.stringify(radio.value)); } catch (e) {}
      }
    }

    /* Honour an earlier pick when that oil is offered here and in stock */
    try {
      var raw = localStorage.getItem(PREF_KEY);
      var pref = raw;
      try { pref = JSON.parse(raw); } catch (e) {}
      if (pref) {
        var match = radios().filter(function (r) { return r.value === pref; })[0];
        if (match) choose(match, false);
      }
    } catch (e) {}
    sync();

    strip.addEventListener('change', function (e) {
      var radio = e.target.closest ? e.target.closest('.azh-fp-input') : null;
      if (radio) choose(radio, true);
    });

    /* ---- All-oils sheet ---- */
    if (!sheet || !openBtn) return;

    var panel = sheet.querySelector('.azh-fp-panel');
    var lastFocus = null;
    var prevOverflow = '';

    /* Escape any transformed ancestors so position: fixed is the viewport */
    if (sheet.parentNode !== document.body) document.body.appendChild(sheet);

    function openSheet() {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
        var target = sheet.querySelector('[data-azh-fp-pick][aria-checked="true"]') || sheet.querySelector('[data-azh-fp-close]');
        if (target) target.focus({ preventScroll: true });
        if (target && target.scrollIntoView) target.scrollIntoView({ block: 'center' });
      });
      document.addEventListener('keydown', onKeydown);
    }

    function closeSheet() {
      sheet.classList.remove('is-open');
      document.body.style.overflow = prevOverflow;
      openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        sheet.hidden = true;
        var back = lastFocus && document.contains(lastFocus) ? lastFocus : openBtn;
        try { back.focus({ preventScroll: true }); } catch (e) {}
      }
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 350);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSheet();
        return;
      }
      if (e.key === 'Tab') {
        var items = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE));
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        return;
      }
      var cell = document.activeElement && document.activeElement.closest ? document.activeElement.closest('[data-azh-fp-pick]') : null;
      if (!cell) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        cell.click();
        return;
      }
      var cells = Array.prototype.slice.call(sheet.querySelectorAll('[data-azh-fp-pick]'));
      var i = cells.indexOf(cell);
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = cells[(i + 1) % cells.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = cells[(i - 1 + cells.length) % cells.length];
      if (next) {
        e.preventDefault();
        next.focus();
      }
    }

    openBtn.addEventListener('click', openSheet);

    sheet.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-azh-fp-close]');
      if (closer) {
        closeSheet();
        return;
      }
      var cell = e.target.closest('[data-azh-fp-pick]');
      if (!cell) return;
      var handle = cell.getAttribute('data-azh-fp-pick');
      var radio = radios().filter(function (r) { return r.getAttribute('data-handle') === handle; })[0];
      if (radio) choose(radio, true);
      closeSheet();
    });
  }

  function boot() {
    document.querySelectorAll('[data-azh-fp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
